import { TEDParseNumberMode } from '../FormatterTypes';
import { TEDCustomNumberDisplayer } from './TEDCustomNumberDisplayer';

class TEDDisplayFloat extends TEDCustomNumberDisplayer {
  public static getInstance(): TEDCustomNumberDisplayer {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDCustomNumberDisplayer;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmFloat;
  }
}

export { TEDDisplayFloat };
